module.exports = "/images/edit.svg?102ec246e5a64edd720edded273f1528";